var _ = require('ES/lib/lodash');
var radio = require('ES/lib/radio');
var esUtils = require('ES/utils/esUtils');

module.exports = {
	getInitialState: function(){
		return {form_uid: _.uniqueId()};
	},
	onFormChanged: function(field_path, new_value){
		this.__checkForChangesMade();
		if (_.isFunction(this.__onFormChanged)) {
			return this.__onFormChanged(field_path, new_value);
		}
	},
	__checkForChangesMade: _.debounce(function(){
		this.updateUnsavedState(
			this.Form_areChangesMade
				? this.Form_areChangesMade() //react-loose-forms
				: this._form_areChangesMade() //old forms
		);
	}, 500),
	__discardChanges: esUtils.wrapPreventDefault(function(){
		if(this.Form_reset){
			this.Form_reset();//react-loose-forms
		}else{
			this._form_reset();//old forms
		}
		this.updateUnsavedState(false);
	}),
	__doTheFormSave: function(onSaveStarted){
		var save_fn = this.Form_onSubmit || this._form_onSubmit;//react-loose-forms || old forms
		save_fn();
		var self = this;
		setTimeout(function(){
			var has_error = _.filter(_.values(self.state.errors)).length > 0;
			onSaveStarted(has_error ? 'Check your input' : undefined);
		}, 500);
	},
	updateUnsavedState: function(is_dirty){
		var event = this.props.event;
    radio('eventFormUnsavedState').broadcast(
			event && event.eid,
			this.state.form_uid,
			is_dirty ? this.__doTheFormSave : undefined
		);
	}
};



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/EventFormUnsavedChangeMixin.js